import React, { useContext, useState, useEffect } from 'react';
import { WorkspaceContext } from '../context/WorkspaceContext';

const SelectWorkspace = () => {
  const { workspaces, selectedWorkspace, selectWorkspace } = useContext(WorkspaceContext);
  const [selected, setSelected] = useState(selectedWorkspace?.id || '');

  useEffect(() => {
    if (selectedWorkspace) {
      setSelected(selectedWorkspace.id);
    }
  }, [selectedWorkspace]);

  const handleChange = (event) => {
    const workspaceId = event.target.value;
    selectWorkspace(workspaceId); 
  };

  return (
    <div 
      style={{ 
        position: 'fixed', 
        top: 0, 
        width: '100%', 
        backgroundColor: '#f8f9fa', 
        padding: '10px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
      }}
    >
      <label htmlFor="workspace-select" style={{ marginRight: '10px' }}>
        Workspace:
      </label>
      <select 
        id="workspace-select" 
        value={selected} 
        onChange={handleChange}
      >
        <option value="" disabled>Seleccione un workspace</option>
        {workspaces.map((workspace) => (
          <option key={workspace.id} value={workspace.id}>
            {workspace.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectWorkspace;
